import { Td, Tr, Typography } from '@aloft/toolkit-sui';

type Props = {
  data: { label: string; value: string | null };
  bold?: boolean;
};

export function ManufacturedCostApproachTableRow(props: Props) {
  const {
    data: { label, value },
    bold,
  } = props;
  const variant = bold ? 'h4' : 'body1';
  return (
    <Tr>
      <Td>
        <Typography variant={variant}>{label}</Typography>
      </Td>
      <Td colSpan={8} className="cost-approach-table-align-right">
        <Typography variant={variant}>{value ?? ''}</Typography>
      </Td>
    </Tr>
  );
}
